import React from 'react';
import { motion } from 'framer-motion';

const AboutUs: React.FC = () => {
  return (
    <div style={{ background: '#f7fafd', minHeight: '100vh', paddingBottom: 60 }}>
      {/* 顶部大图 */}
      <motion.div
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -40 }}
        transition={{ duration: 0.8 }}
        style={{
          width: '100%',
          height: 600,
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#eaf0fa',
          marginBottom: 40,
        }}
      >
        <img
          src="/about us.jpg"
          alt="About Us"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            objectPosition: 'center',
            borderRadius: 0,
            boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
          }}
        />
      </motion.div>

      {/* 文字+图片区域 */}
      <div
        style={{
          maxWidth: 1100,
          margin: '0 auto',
          background: '#fff',
          borderRadius: 18,
          boxShadow: '0 4px 24px rgba(0,0,0,0.07)',
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          padding: 40,
          gap: 40,
        }}
      >
        {/* 左侧图片 */}
        <motion.div
          initial={{ opacity: 0, x: -60 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          style={{
            flex: 1,
            minWidth: 260,
            maxWidth: 380,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img
            src="/about us bed.jpg"
            alt="Showroom"
            style={{
              width: '100%',
              maxWidth: 340,
              borderRadius: 14,
              boxShadow: '0 2px 16px rgba(0,0,0,0.10)',
            }}
          />
        </motion.div>
        {/* 右侧文字 */}
        <motion.div
          initial={{ opacity: 0, x: 60 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
          style={{ flex: 2, minWidth: 280, textAlign: 'left' }}
        >
          <h2 style={{ fontWeight: 800, fontSize: 32, color: '#222', marginBottom: 18, letterSpacing: 1, textAlign: 'center' }}>
            About Us
          </h2>
          <p style={{ fontSize: 18, color: '#444', lineHeight: 1.8, marginBottom: 18 }}>
            After working alongside many Home Owners and Designers in GTA, we have been able to select our inventory based on today's design demand. We offer a wide range of stylish rental furniture and accessories from Condos to Houses. A conveniently located showroom with knowledgeable and friendly staffs, and a fast and easy online ordering experince. We are constantly looking to add to our collection of furniture to help you create the best design for your clients or your own lovely homes.
          </p>
          <p style={{ fontSize: 18, color: '#444', lineHeight: 1.8, marginBottom: 18 }}>
            We provide excellent servie with reasonable and competitive price. Our staffs and delivery team provide excellent service in a timely manner as well as being polite, professional and mindful. We have helped with tight deadlines, alternative product solutions, fast turnaround for deliveries and pickups as well as creative suggestions for room redesigns.
          </p>
          <p style={{ fontSize: 18, color: '#444', lineHeight: 1.8 }}>
            We welcome you to see our 12,000 sq ft warehouse, where our knowledgeable and experience staffs would be happy to help. We are open 6 days a week and Sundays by appointment, please call us to set up a time for us to be able to assist you better.
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default AboutUs;